import { Button, Modal, SegmentedControl } from '@telegram-apps/telegram-ui'
import { useDevToolsStore, type DevToolsMode } from 'shared/store/devtools'
import { defaultDevWidgetPos } from '../lib/safe-area'
import { AccountSwitcher } from './AccountSwitcher'
import { ApiEndpointSelect } from './ApiEndpointSelect'
import { RouteNavigator } from './RouteNavigator'

const MODES: { value: DevToolsMode; label: string }[] = [
	{ value: 'off', label: 'Off' },
	{ value: 'on', label: 'On' },
	{ value: 'eruda', label: 'Eruda' },
]

export function DevSheet({ routePaths }: { routePaths: readonly string[] }) {
	const mode = useDevToolsStore((s) => s.mode)
	const sheetOpen = useDevToolsStore((s) => s.sheetOpen)
	const setSheetOpen = useDevToolsStore((s) => s.setSheetOpen)
	const setMode = useDevToolsStore((s) => s.setMode)
	const setIconPos = useDevToolsStore((s) => s.setIconPos)

	const pickMode = (next: DevToolsMode) => {
		setMode(next)
		// 'off' hides everything; 'eruda' hands the screen over to eruda's own
		// panel (both floating panels at once would collide). 'on' keeps the
		// sheet open so the other tools remain usable.
		if (next !== 'on') setSheetOpen(false)
	}

	return (
		<Modal
			open={sheetOpen}
			onOpenChange={setSheetOpen}
			header={<Modal.Header>Dev tools</Modal.Header>}
		>
			<div className="space-y-6 px-4 pb-8">
				<SegmentedControl>
					{MODES.map(({ value, label }) => (
						<SegmentedControl.Item
							key={value}
							selected={mode === value}
							onClick={() => pickMode(value)}
						>
							{label}
						</SegmentedControl.Item>
					))}
				</SegmentedControl>
				<Button
					size="s"
					mode="outline"
					stretched
					onClick={() => setIconPos(defaultDevWidgetPos())}
				>
					Reset icon position
				</Button>
				<hr className="border-[var(--tgui--outline,rgba(255,255,255,0.1))]" />
				<AccountSwitcher />
				<hr className="border-[var(--tgui--outline,rgba(255,255,255,0.1))]" />
				<RouteNavigator paths={routePaths} />
				<ApiEndpointSelect />
			</div>
		</Modal>
	)
}
